(function () {
    var activation_campaign_step1_slider = new Swiper(".js_activation_campaign_slider", {
    spaceBetween: 70,
    slidesPerView: 2,
    loop: true,
    slidesPerGroup: 2,
    navigation: {
        nextEl: ".js_activation_campaign_slider .swiper-button-next",
        prevEl: ".js_activation_campaign_slider .swiper-button-prev",
    },
    });
})();